import { Component } from '@angular/core';
import { NavController, NavParams, PopoverController, ModalController, ToastController, AlertController } from 'ionic-angular';
import { DIC } from '../../../dic';
import { GN } from '../../../../gn';
import * as moment from 'moment';
import { PopupPage } from '../../../popup/popup';
import { CalendarPage } from '../../../calendar/calendar';
import { NeworderbankPage } from '../neworderbank/neworderbank';

import { PrintreportPage } from './printreport';
import { PoinotePage } from '../../../poinote/poinote';
import { HistorylognalogPage } from './historylognalog';
import { RoutingnalogbankPage } from './routingnalogbank';
import { PNMaps } from '../../../../pan.maps';

/**
 * Generated class for the ReportorderbankPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-reportorderbank',
  templateUrl: 'reportorderbank.html',
})
export class ReportorderbankPage {
  startDateA: any = new Date()
  startDateStrA: any = moment(new Date()).format(this.gn.user.DFormat)
  startDateB: any = new Date()
  startDateStrB: any = moment(new Date()).format(this.gn.user.DFormat)

  selectedVehicleName = '--- ' + this.dic.l["choosevehicle"] + ' ---';
  selectedVehicleID = -1;

  InFocused = false
  AutoCompleteShow2 = false
  AutoCompleteState2 = 0
  LoadingDataSearch2 = false
  mapSearcData2 = []
  AutoCompleteTitle = ''
  r_routeName = ''
  r_routeId = 0
  loadingData = false


  reportData = []


  reportDataToday = []
  reportDataOld = []
  reportDataNew = []
  reportDDD = []
  tmpGoran = 1
  r_routeNumber = ''

  mdl

  Denes = moment(new Date()).format('YYYY-MM-DD')
  myLon: any
  myLat: any
  isMyPozOK = false

  constructor(public panMaps: PNMaps, public navCtrl: NavController, public navParams: NavParams, public dic: DIC, public gn: GN, public popoverCtrl: PopoverController, public modalCtrl: ModalController, public toastCtrl: ToastController, public alertCtrl: AlertController) {
    if (this.gn.user.driverid + '' != '-1') {
      this.panMaps.isPozWatching = false
      this.panMaps.isMyPozOK = false
    }
  }

  ionViewDidLoad() {
    var _that = this
    if (this.gn.user.driverid + '' != '-1') {
      this.panMaps.getDriverPosition(function (_lat, _lng, _isMyPozOK) {
        _that.myLat = _lat
        _that.myLon = _lng
        _that.isMyPozOK = _isMyPozOK
      })
    }

    this.loadReport();
    // console.log('ionViewDidLoad ReportorderbankPage');
  }


  // print(_id) {
  //   var _that = this
  //   let modal = this.modalCtrl.create(PrintreportPage, {
  //     _id: 1, cb: function () {
  //       // _that.loadData()
  //     }
  //   }, { cssClass: "modal-fullscreen2" });
  //   modal.present()
  // }

  openVehiclePopup(_ev) {

    var _that = this
    let popover = this.popoverCtrl.create(PopupPage, {
      type: 'vehicles-routing', selected: [], callback: function (_text, _ids) {

        // console.log(_text, _ids)
        // _that.selectedVehiclesIds = _ids
        // _that.selectedVehiclesText = _text

        _that.selectedVehicleName = _text;
        _that.selectedVehicleID = parseInt(_ids);

        // console.log(_that.selectedVehicleID, _that.selectedVehicleName)
      }
    });
    popover.present({
      ev: _ev
    });
  }



  searchGeocode2(txt) {
    txt = txt.toLowerCase()
    // txt = txt.replace(/ /g,'%')
    // console.log(txt)
    if (txt == '' || txt.length <= 3) {
      this.mapSearcData2 = []
      this.AutoCompleteState2 = 0
      return
    }
    var _that = this
    var _lon = 21.431068
    var _lat = 41.995759

    this.LoadingDataSearch2 = true
    _that.AutoCompleteState2 = 1

    if (txt != '' && txt.length > 3) {
      this.gn.Socket.emit({ query: txt, lon: _lon, lat: _lat, clientid: this.gn.user.ClientId }, function (_data) {
        //  console.log(_data)
        _that.mapSearcData2 = []
        for (var i = 0; i < _data.length; i++) {
          if (_data[i].ppid + '' != '0') {
            _that.mapSearcData2.push(_data[i])
          }
        }

        _that.LoadingDataSearch2 = false
        if (_that.mapSearcData2.length == 0) {
          _that.AutoCompleteState2 = 2
        } else {
          _that.AutoCompleteState2 = 1
        }
        // console.log (_that.mapSearcData)
      }, 'getgeocodenlb')
    }
  }

  openAutocomplete2(_ev) {

    this.mapSearcData2 = []
    this.LoadingDataSearch2 = false
    this.AutoCompleteState2 = 0

    this.InFocused = true
    var _txt = _ev.target.value
    if (_txt == '') {
      _txt = this.dic.l['Search'] + '...'
      this.AutoCompleteState2 = 0
    } else {
      _txt = this.dic.l['Search'] + ': ' + _txt
      this.AutoCompleteState2 = 1
    }
    this.searchGeocode2(_ev.target.value)
    // this.AutoCompleteTitle2 = _txt
    // var _top = _ev.target.parentNode.parentNode.parentNode.parentNode.parentNode.offsetTop
    this.AutoCompleteShow2 = true
    // this.AutoCompleteTop = (_top + 71) + 'px'
  }
  hideAutocomplete2() {
    //if (this.r_routeName == '') { this.selectedPoiRep = null }
    this.InFocused = false
    var _that = this
    setTimeout(function () {
      if (_that.InFocused == false) {
        _that.AutoCompleteShow2 = false
      }
    }, 150)
    // this.AutoCompleteShow = false
  }
  txtchange2(_ev) {
    var _txt = _ev.target.value
    var t = _ev.target.value
    if (_txt == '') {
      _txt = this.dic.l['Search'] + '...'
    } else {
      _txt = this.dic.l['Search'] + ': ' + _txt
    }
    // this.AutoCompleteTitle = _txt


    // var _that = this
    if (t != '') {
      this.searchGeocode2(_ev.target.value)
    } else {
      this.mapSearcData2 = []
      this.AutoCompleteState2 = 0
      // console.log (_that.mapSearcData)
    }
  }

  itemACClick2(_itm) {
    this.AutoCompleteShow2 = false
    // this.selectedPoiRep = { txt: '', lon: 0, lat: 0, ppid: 0 }

    // this.selectedPoiRep.txt = _itm.name
    // this.selectedPoiRep.lon = _itm.lon
    // this.selectedPoiRep.lat = _itm.lat
    // this.selectedPoiRep.ppid = _itm.ppid
    // this.r_routeName = _itm.name
    this.r_routeName = _itm.name
    this.r_routeId = _itm.ppid
  }


  openDatePopup(_ev, _se) {
    var dd = this.startDateA
    if (_se == 2) {
      dd = this.startDateB
    }
    var _that = this;
    let popover = this.popoverCtrl.create(CalendarPage, {
      d: dd, cb: function (d) {
        // console.log(d)
        if (_se == 1) {
          _that.startDateA = d;
          _that.startDateStrA = moment(_that.startDateA).format(_that.gn.user.DFormat)
        } else {
          _that.startDateB = d;
          _that.startDateStrB = moment(_that.startDateB).format(_that.gn.user.DFormat)
        }
      }
    })
    popover.present({ ev: _ev });
  }


  sec2str2(_sec) {
    if (_sec >= 0) {
      var str = '';
      var h = Math.floor(_sec / 3600);//moment.utc(_sec * 1000).format('H');
      var m = moment.utc(_sec * 1000).format('m');
      var s = moment.utc(_sec * 1000).format('s');
      if (_sec < 60) {
        str = s + this.dic.l["sec"];
      }
      else {
        if (_sec < 3600) {
          str = m + this.dic.l["min"] + ' ' + s + this.dic.l["sec"]
        }
        else {
          str = h + this.dic.l["h"] + ' ' + m + this.dic.l["min"]
        }
      }
      // console.log("sec2str2")  
      return str;
    }
    else {
      return -1;
    }
  }

  editBankRoute(_idxmaster, _idx, _id) {
    var _that = this
    this.mdl = this.modalCtrl.create(NeworderbankPage, {
      ref: this, id: _id, edittype: 'editroute', routedata: this.reportDDD[_idxmaster].data[_idx],
      cb: function () {
        setTimeout(() => {
          _that.loadReport();
        }, 1000);
      }
    }, { cssClass: "modal-fullscreen" }
    );
    this.mdl.present()
  }

  showOnMap(_idxmaster, _idx, _id) {
    var _that = this
    this.gn._Post('/api/gn/getroutesOneBank', { pre: this.gn.crypt('0'), cid: this.gn.crypt(this.gn.user.ClientId), nid: this.gn.crypt(_id) }, function (_data) {
      let profileModal = _that.modalCtrl.create(RoutingnalogbankPage, {
        cb: function (_id) {
        }, rid: _id, pois: _data
      });
      profileModal.present();
    })

  }

  loadReport() {
    this.tmpGoran = 1
    //this.showReportPanel = true
    this.loadingData = true
    this.reportData = []
    this.reportDataToday = []
    this.reportDataOld = []
    this.reportDataNew = []
    this.reportDDD = []
    var d1 = moment(this.startDateA).format('YYYY-MM-DD')
    var d2 = moment(this.startDateB).format('YYYY-MM-DD')
    var ppid = ''
    if (this.r_routeId != null && this.r_routeId > 0) {
      ppid = this.r_routeId + ''
    }

    var vid = '0'
    if (this.selectedVehicleID + '' != '-1') {
      vid = this.selectedVehicleID + ''
      var vida = [];
      vida.push(vid)
    }
    var _dat = {
      num: this.gn.crypt(this.r_routeNumber),
      vid: this.gn.crypt(vid),
      d1: this.gn.crypt(d1),
      d2: this.gn.crypt(d2),
      poiid: this.gn.crypt(ppid),
      uid: this.gn.crypt(this.gn.user.UserId),
      udid: this.gn.crypt(this.gn.user.driverid)
    }
    var logvozila = ' за сите возила';
    if (vid != '0') {
      logvozila = ' за возилата: ' + this.gn.getVehiclesLog(vida);
    }

    var logNalog = '; Налог бр: ' + (this.r_routeNumber == '' ? '/' : this.r_routeNumber) + '; '
    var logPoi = ' Точка од интерес: ' + (this.r_routeId == null ? '/' : this.r_routeName)
    var logperiod = 'Период од: ' + moment(d1).format('DD-MM-YYYY 00:00:00') + ' до: ' + moment(d2).format('DD-MM-YYYY 23:59:59');
    this.gn.addLog(37, logperiod + logvozila + logNalog + logPoi);

    var _that = this
    this.gn._Post('/api/gn/routingreport', _dat, function (_data) {
      // console.log(_data, 'data')
      //debugger;
      _that.loadingData = false
      var _lasttourid = ''
      _that.reportData = []
      var _pois = []
      var poiIdx = 1
      for (var i = 0; i < _data.length; i++) {

        if (_data[i].tourid + '' != _lasttourid) {

          if (_that.reportData.length > 0) {
            _that.reportData[_that.reportData.length - 1].pois = []
            for (var j = 0; j < _pois.length; j++) {
              _that.reportData[_that.reportData.length - 1].pois.push(_pois[j])
            }
            _that.reportData[_that.reportData.length - 1].poisArr = _pois
            _that.reportData[_that.reportData.length - 1].poisStr = _pois.join(', ')
            // _that.reportData[_that.reportData.length-1].pois = _pois
          }
          _pois = []
          poiIdx = 1
          var soferi = []
          if (_data[i].s1 != null) { soferi.push(_data[i].s1) }
          if (_data[i].s2 != null) { soferi.push(_data[i].s2) }
          if (_data[i].s3 != null) { soferi.push(_data[i].s3) }
          if (_data[i].s4 != null) { soferi.push(_data[i].s4) }
          _data[i].sofer = soferi.join(', ')
          _data[i].datum = moment(_data[i].startdate).format(_that.gn.user.DFormat) + ' ' + moment(_data[i].startdate).format(_that.gn.user.TFormat)
          _data[i].dYMD = moment(_data[i].startdate).format('YYYY-MM-DD')

          _data[i].distance = parseFloat(_data[i].totalkm).toFixed(1) + ' Km'
          _data[i].ttime = parseInt(_data[i].totaltime)
          var _pauses = []
          if (_data[i].pause1 + '' != '0') { _pauses.push(_data[i].pause1 + ' ' + _that.dic.l["min"]) }
          if (_data[i].pause2 + '' != '0') { _pauses.push(_data[i].pause2 + ' ' + _that.dic.l["min"]) }
          if (_data[i].pause3 + '' != '0') { _pauses.push(_data[i].pause3 + ' ' + _that.dic.l["min"]) }
          if (_data[i].pause4 + '' != '0') { _pauses.push(_data[i].pause4 + ' ' + _that.dic.l["min"]) }
          if (_data[i].pause5 + '' != '0') { _pauses.push(_data[i].pause5 + ' ' + _that.dic.l["min"]) }
          _data[i].pauses = _pauses.join(', ')
          _lasttourid = _data[i].tourid + ''

          _that.reportData.push(_data[i])
        }
        //_pois.push('  [' + poiIdx + '. ' + _data[i].name + ' ' + _data[i].rbr1 + ' ' + _data[i].timeinp + ' ' + _data[i].timeoutp + ' ' + _that.sec2str2(_data[i].diff) + ']')
        //_pois.push({ idx: poiIdx, name: _data[i].name, id: _data[i].poiid, checked: _data[i].checked, rbr1: _data[i].rbr1, timein: _data[i].timeinp, timeout: _data[i].timeoutp, idle: _that.sec2str2(_data[i].diff) })

        //_pois.push('  [' + poiIdx + '. ' + _data[i].name + ' ' + _data[i].rbr1 + ' ' + _data[i].timeinp + ' ' + _data[i].timeoutp + ' ' + _that.sec2str2(_data[i].diff) + ']')
        var note = _data[i].note;//''
        var noteid = _data[i].noteid;//-1
        var visited = '0'

        //if (_that.gn.user.driverid + '' != '-1') {
        note = _data[i].note + '' != '' ? _data[i].note : '';
        noteid = _data[i].noteid + '' != '-1' ? _data[i].noteid : -1;
        visited = (_data[i].visited == null ? '0' : _data[i].visited);

        //}
        _pois.push({ appcolor: _data[i].appcolor, lonvisited: _data[i].lonvisited, latvisited: _data[i].latvisited, lon: _data[i].longitude, lat: _data[i].latitude, visited: visited, note: note, noteid: noteid, idx: poiIdx, name: _data[i].name, id: _data[i].poiid, checked: _data[i].checked, rbr1: _data[i].rbr1, timein: _data[i].timeinp, timeout: _data[i].timeoutp, idle: _that.sec2str2(_data[i].diff), diff: _data[i].diff })

        poiIdx = poiIdx + 1

      }
      if (_that.reportData.length > 0) {
        _that.reportData[_that.reportData.length - 1].pois = []
        for (var j = 0; j < _pois.length; j++) {
          _that.reportData[_that.reportData.length - 1].pois.push(_pois[j])
        }
        _that.reportData[_that.reportData.length - 1].poisArr = _pois
        _that.reportData[_that.reportData.length - 1].poisStr = _pois.join(', ')
        // _that.reportData[_that.reportData.length-1].pois = _pois
      }

      for (var i = 0; i < _that.reportData.length; i++) {
        if (_that.reportData[i].dYMD < _that.Denes) {
          _that.reportDataOld.push(_that.reportData[i])
        }
        if (_that.reportData[i].dYMD == _that.Denes) {
          _that.reportDataToday.push(_that.reportData[i])
        }
        if (_that.reportData[i].dYMD > _that.Denes) {
          _that.reportDataNew.push(_that.reportData[i])
        }
      }
      //debugger
      if (_that.gn.user.driverid + '' == '-1')
        _that.reportDDD.push({ title: 'Идни налози', data: _that.reportDataNew })
      _that.reportDDD.push({ title: 'Денешни налози', data: _that.reportDataToday })
      if (_that.gn.user.driverid + '' == '-1')
        _that.reportDDD.push({ title: 'Изминати налози', data: _that.reportDataOld })

      // _that.reportData = _data
      // console.log(_that.reportData)

      setTimeout(function () {
        // _that.XLSDataAll.push({ spentffuel: _spentdayvalue, datesss: _dtall, avgkmspent: _listajprosecno, vomesto: _stayspentfuel })
        //_that.XLSDataAll = _that.reportData


      }, 200)
      _that.gn.xlsFunction = function () {
        //_that.createXLS()
      }


    })
  }

  addPoiNote(poiobj, hederid) {
    //this.reportDDD[idxMaster].data[i1].pois[i]
    if (this.gn.user.driverid + '' == '-1')
      return false;

    var _that = this
    let modal = this.modalCtrl.create(PoinotePage, {
      obj: poiobj, hederid: hederid, cb: function (note, noteid) {
        poiobj.note = note;
        poiobj.noteid = noteid;
      }
    }, { cssClass: "modal-fullscreen7" });
    modal.present()
  }

  checkPoiNote(poiobj, hederid) {
    var _that = this
    if (this.isMyPozOK) {
      poiobj.visited = (poiobj.visited == null ? '1' : (poiobj.visited == '1' ? '0' : '1'))
      //this.panMaps.getDriverPosition(function (_lat, _lng, _isMyPozOK) {
      var _dat = {
        cid: _that.gn.crypt(_that.gn.user.ClientId),
        uid: _that.gn.crypt(_that.gn.user.UserId),
        hederid: _that.gn.crypt(hederid),
        note: _that.gn.crypt(poiobj.note == null ? '' : poiobj.note),
        noteid: _that.gn.crypt(poiobj.noteid == null ? -1 : poiobj.noteid),
        poiid: _that.gn.crypt(poiobj.id),
        rbr: _that.gn.crypt(poiobj.idx),
        visited: _that.gn.crypt(poiobj.visited),
        insertnote: _that.gn.crypt(0),
        lat: _that.gn.crypt(this.myLat),
        lng: _that.gn.crypt(this.myLon)
      }
      _that.gn._Post('/api/insertPoiNote', _dat, function (_data) {
        poiobj.noteid = _data.noteid;
      })
    } else {
      const toast = _that.toastCtrl.create({
        message: _that.dic.l['locationserviceerror'],
        duration: 3000,
        position: 'top'
      });
      toast.present();
    }
    //})
  }

  navigateToPoiRoute(_this, _poi) {
    var _lon = 21.427379;
    var _lat = 41.998802;
    var _url = '/'
    for (var v = 0; v < this.gn.Vehicles.length; v++) {
      var tf = false;
      if (this.gn.Vehicles[v].driver + '' == this.gn.user.UserFullName + '') {
        _lon = parseFloat(this.gn.Vehicles[v].lon)
        _lat = parseFloat(this.gn.Vehicles[v].lat)
        _url = "https://www.google.com/maps/dir/" + _lat + "," + _lon + "/" + _poi.lat + "," + _poi.lon + "/data=!3m1!4b1!4m2!4m1!3e0"
        document.getElementById('a-poi-' + _poi.id).setAttribute("href", _url);
      }
    }
  }

  printNalog(_u) {
    var _that = this
    let modal = this.modalCtrl.create(PrintreportPage, {
      did: _u, cb: function () {
        // _that.loadData()
      }
    }, { cssClass: "modal-fullscreen2" });
    modal.present()
  }

  historyNalog(_u, _c) {
    if (_c == 0)
      return false;

    var _that = this
    let modal = this.modalCtrl.create(HistorylognalogPage, {
      did: _u, cb: function () {
        // _that.loadData()
      }
    }, { cssClass: "modal-fullscreen" });
    modal.present()
  }

  proba(id: number, idx: number, idxmaster: number) {
    console.log(this.reportDDD, '_that.reportDDD')
  }

  deleteNalog(id: number, idx: number, idxmaster: number) {
    console.log(id, 'dali e toj idx')
    // console.log(idxmaster, 'dali e toj idxmaster')

    var _that = this;
    let alert = _that.alertCtrl.create({
      title: _that.dic.l["deleteNalog"],
      subTitle: _that.dic.l["areyouwantodellDuty"] + ' ' + id,
      buttons: [
        {
          text: _that.dic.l['ok'],
          handler: data => {
            _that.gn.loadWaiting();
            this.gn._Post('/api/gn/delNalogHeder', { id: this.gn.crypt(id) }, function (_data) {
              _that.gn.loaderWaiting.dismiss();
              // debugger

              // for (let i = 0; i < _that.reportDDD.length; i++) {
              //   for (let j = 0; j < _that.reportDDD[i].data.length; j++) {
              _that.reportDDD[idxmaster].data.splice(idx, 1);

              //     _that.reportDDD[idxmaster].data[j].splice(idx, 1);
              //     console.log(_that.reportData, 'report da vidam')
              // }
              // }
            })
          }
        },
        {
          text: _that.dic.l['cancel'],
          role: 'cancel'
        }
      ]
    });
    alert.present();
  }

  // showOnMap(_u, _c) {

  // }
}



// WEBPACK FOOTER //
// ./src/pages/routing/routebank/reportorderbank/reportorderbank.ts